import {
  Box,
  Container,
  Heading,
  HStack,
  IconButton,
  Img,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import Slider, { Settings } from 'react-slick';
import { hearGreenReturnLeader } from '@/constants/pages/altCap101-video';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import PlayVideo from '../vc-101/PlayVideo';

export interface IVideo {
  id: string;
  title: string;
  url: string;
  description?: string;
  milis_length?: number;
  length: string;
  thumbnail_url: string;
}

const HighlightedVideo: React.FC<{
  video: IVideo;
  onOpen: () => void;
  setActiveVideo: React.Dispatch<React.SetStateAction<IVideo>>;
}> = ({ onOpen, setActiveVideo, video }) => (
  <Container maxW="container.lg" bgColor="white" p="10px " borderRadius="8px">
    <Box pos="relative">
      <Box
        pos="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        bg="linear-gradient(180deg, rgba(10.34, 155.13, 129.49, 0.60) 0%, rgba(68.14, 68.14, 157.25, 0.60) 69%)"
        borderRadius="8px"
      />
      <IconButton
        aria-label="play-button"
        boxSize="30px"
        pos="absolute"
        top="50%"
        left="50%"
        variant="unstyled"
        transform="translate(-50%, -50%)"
        icon={<Img src="/svg/play-101.svg" />}
        onClick={() => {
          setActiveVideo(video);
          onOpen();
        }}
      />
      <Img
        src={video.thumbnail_url}
        objectFit="cover"
        borderRadius="8px"
        w="100%"
        maxH="571px"
      />
    </Box>
    <Box mt="13px" mb="22px">
      <Heading as="h3" fontSize="18px">
        {video.title}
      </Heading>
      <Text color="#3D3D5FC7" mt="4px">
        {video.description}
      </Text>
    </Box>
  </Container>
);

const LeaderVideo: React.FC = () => {
  const sliderRef = React.useRef<Slider>(null);
  const [activeVideo, setActiveVideo] = React.useState<IVideo>({} as IVideo);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const config: Settings = {
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <>
      <PlayVideo isOpen={isOpen} onClose={onClose} video={activeVideo} />

      <HStack w="full" alignItems="center">
        <Box w="100%" position="relative">
          <Slider ref={sliderRef} {...config}>
            <HighlightedVideo
              onOpen={onOpen}
              setActiveVideo={setActiveVideo}
              video={hearGreenReturnLeader[0]}
            />
          </Slider>
        </Box>
      </HStack>
    </>
  );
};

export default LeaderVideo;
